import React from "react";
import {useTranslation} from "react-i18next";

const SignContractFileDataView = ({data, countries, addClass}) => {
  const {t} = useTranslation();

  const itemLanguageKey = "SIGN_CONTRACT_DATA_FILEDATA_";

  const hasAddressFields =
    data.companyAddressMain ||
    data.companyAddressExtra ||
    data.companyAddressPostalCode ||
    data.companyAddressCity;
  const hasDeliveryAddress =
    data.deliveryAddressMain ||
    data.deliveryAddressExtra ||
    data.deliveryAddressPostalCode ||
    data.deliveryAddressCity;
  const hasCounterpartyAddress =
    data.counterpartyCompanyAddressMain ||
    data.counterpartyCompanyAddressExtra ||
    data.counterpartyCompanyAddressPostalCode ||
    data.counterpartyCompanyAddressCity;
  const hasContactFields =
    data.initiatingContactFullName ||
    data.initiatingContactEmail ||
    data.initiatingContactMobilePhone;
  const hasDeliveryContactFields =
    data.deliveryContactFullName ||
    data.deliveryContactEmail ||
    data.deliveryContactMobilePhone;
  const hasCounterpartyContactFields =
    data.counterpartyContactFullName ||
    data.counterpartyContactEmail ||
    data.counterpartyContactMobilePhone;
  const hasFirstColumn = hasAddressFields || hasContactFields;
  const hasSecondColumn = hasDeliveryAddress || hasDeliveryContactFields;
  const hasThirdColumn =
    data.counterpartyCompanyName ||
    data.counterpartyCompanyNumber ||
    hasCounterpartyAddress;
  const hasFourthColumn = hasCounterpartyContactFields;

  const FileDataLabel = ({label, value, addClass}) =>
    value && (
      <div className={addClass}>
        {label && <div className="__uppercase __bold fz-10 mb-1">{t(label)}</div>}
        <div className="fz-13">{value}</div>
      </div>
    );

  return (
    <div className={`df-row pa-2 border-form${addClass ? ` ${addClass}` : ""}`}>
      {hasFirstColumn && (
        <div className="mr-8">
          <FileDataLabel
            label={`${itemLanguageKey}CUSTOMER_DATA`}
            value={data.companyName}
          />
          <FileDataLabel value={data.companyNumber} addClass="mb-2" />
          <FileDataLabel value={data.companyAddressMain} />
          <FileDataLabel value={data.companyAddressExtra} />
          <FileDataLabel
            value={`${data.companyAddressPostalCode} ${data.companyAddressCity}`}
          />
          <FileDataLabel
            value={
              countries.find((country) => country.value === data.companyAddressCountry)
                ?.label ?? ""
            }
          />
          <FileDataLabel
            label={`${itemLanguageKey}CUSTOMER_CONTACT_DATA`}
            value={data.initiatingContactFullName}
            addClass={hasAddressFields ? "mt-4" : ""}
          />
          <FileDataLabel value={data.initiatingContactEmail} />
          <FileDataLabel value={data.initiatingContactMobilePhone} />
        </div>
      )}
      {hasSecondColumn && (
        <div className="mr-8">
          <FileDataLabel
            label={`${itemLanguageKey}DELIVERY_ADDRESS`}
            value={data.deliveryAddressMain}
            addClass="mb-4"
          />
          <FileDataLabel value={data.deliveryAddressExtra} />
          <FileDataLabel
            value={`${data.deliveryAddressPostalCode} ${data.deliveryAddressCity}`}
          />
          <FileDataLabel
            value={
              countries.find((country) => country.value === data.deliveryAddressCountry)
                ?.label ?? ""
            }
          />
          <FileDataLabel
            label={`${itemLanguageKey}DELIVERY_CONTACT_DATA`}
            value={data.deliveryContactFullName}
            addClass={hasAddressFields ? "mt-4" : ""}
          />
          <FileDataLabel value={data.deliveryContactEmail} />
          <FileDataLabel value={data.deliveryContactMobilePhone} />
        </div>
      )}
      {hasThirdColumn && (
        <div className="mr-8">
          <FileDataLabel
            label={`${itemLanguageKey}SUPPLIER_DATA`}
            value={data.counterpartyCompanyName}
          />
          <FileDataLabel value={data.counterpartyCompanyNumber} addClass="mb-2" />
          <FileDataLabel value={data.counterpartyCompanyAddressMain} />
          <FileDataLabel value={data.counterpartyCompanyAddressExtra} />
          <FileDataLabel
            value={`${data.counterpartyCompanyAddressPostalCode} ${data.counterpartyCompanyAddressCity}`}
          />
          <FileDataLabel
            value={
              countries.find(
                (country) => country.value === data.counterpartyCompanyAddressCountry
              )?.label ?? ""
            }
          />
        </div>
      )}
      {hasFourthColumn && (
        <div>
          <FileDataLabel
            label={`${itemLanguageKey}SUPPLIER_CONTACT_DATA`}
            value={data.counterpartyContactFullName}
          />
          <FileDataLabel value={data.counterpartyContactEmail} />
          <FileDataLabel value={data.counterpartyContactMobilePhone} />
        </div>
      )}
    </div>
  );
};

export default SignContractFileDataView;
